const TEXT_COLOR = '#777676';
const FONT_SIZE = '0.8rem';
const TICK_COLOR = '#979797';
const STROKE_COLOR = '#979797';
const STROKE_WIDTH = 0.4;

export {
  TEXT_COLOR, FONT_SIZE, TICK_COLOR, STROKE_COLOR, STROKE_WIDTH,
};
